export function validaCnpj(cnpj) {
  let cnpjLimpo = cnpj.replace(/[^\d]+/g, '');
  let valida = cnpjLimpo.length === 14;
  let numeros = cnpjLimpo.substring(0, 12);
  let digitos = cnpjLimpo.substring(12);
  let Soma = 0;
  let pos = 5;

  if (valida) {
    for (let i = 0; i < 12; i++) {
      Soma += numeros.charAt(i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }

    let resultado = Soma % 11 < 2 ? 0 : 11 - (Soma % 11);
    if (resultado !== parseInt(digitos.charAt(0))) {
      valida = false;
    }

    Soma = 0;
    pos = 6;

    for (let i = 0; i < 13; i++) {
      Soma += cnpjLimpo.charAt(i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }

    resultado = Soma % 11 < 2 ? 0 : 11 - (Soma % 11);
    if (resultado !== parseInt(digitos.charAt(1))) {
      valida = false;
    }
  }

  return valida;
}

